<section class="login-section3">
  <div class="logo-section" style="text-align: center;">
    <a routerLink="/access/login" style="text-decoration: none; display: inline-flex; align-items: center;">
      <img src="./assets/images/shift.png" style="margin-right: 10px;" alt="FleetConnect Logo">
      <span style="font-weight: bold; font-size: 1.2rem; color: black;">FleetConnect</span>
    </a>
  </div>
    <div class="login-box">
<router-outlet></router-outlet>

    </div>
</section>
